// src/components/USP.jsx
import React from 'react';
import {useTranslation} from "react-i18next";

function USP() {
    const [t, i18n] = useTranslation();
    return (
        <section className="usp-section container">
            {/* Main Title */}
            <h2 className="section-main-title text-center">
                <mark className="yellow">{t('usp.title_yellow')}</mark>{t('usp.title')}
            </h2>

            <p className="usp-description text-center">{t('usp.description')}</p>

            {/* Three USP Cards */}
            <div className="row text-center usp-cards">
                {/* Card 1 */}
                <div className="col-md-4">
                    <div className="usp-card">
                        <div className="usp-circle"><img src="/Images/USPs/intelligent-matching-tool.jpeg" style={{maxWidth: "100%"}}/>
                        </div>
                        <div className="usp-card-title-container">
                            <h3 className="usp-card-title">{t('usp.card1.title')}</h3>
                        </div>
                        <p className="usp-card-text">
                            {t('usp.card1.description')}
                        </p>
                    </div>
                </div>
                {/* Card 2 */}
                <div className="col-md-4">
                    <div className="usp-card">
                        <div className="usp-circle"><img src="/Images/USPs/end-to-end-enrolment-system-scheduling.jpeg" style={{maxWidth: "100%"}}/>
                        </div>
                        <div className="usp-card-title-container">
                            <h3 className="usp-card-title">{t('usp.card2.title')}</h3>
                        </div>
                        <p className="usp-card-text">{t('usp.card2.description')}</p>
                    </div>
                </div>
                {/* Card 3 */}
                <div className="col-md-4">
                    <div className="usp-card">
                        <div className="usp-circle"><img src="/Images/USPs/maximize-time-simplify-activity-coordination.jpeg" style={{maxWidth: "100%"}}/>
                        </div>
                        <div className="usp-card-title-container">
                            <h3 className="usp-card-title">{t('usp.card3.title')}</h3>
                        </div>
                        <p className="usp-card-text">{t('usp.card3.description')}</p>
                    </div>
                </div>
            </div>

            <h3 className="section-main-subtitle text-center">
                {t('usp.subtitle_before')}<mark className="yellow">{t('usp.subtitle_yellow')}</mark>{t('usp.subtitle_after')}
            </h3>
        </section>
    );
}

export default USP;
